import { render } from "./AddExpense.vue?vue&type=template&id=4454ee29"
import script from "./AddExpense.vue?vue&type=script&lang=js"
export * from "./AddExpense.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__